import theme, {LOADED_THEME} from '../../../../services/theme'

export default {
    menu: {
        background: theme.palette.toolbar.item.background,
        ...LOADED_THEME.headerSubmenu.style
    },
    menuItem: {
        color: theme.palette.toolbar.item.color,
        ...LOADED_THEME.headerSubmenuItem.style,
        ['&:hover']: {
            color: theme.palette.toolbar.item.hoverColor,
            background: theme.palette.toolbar.item.hover
        }
    }
}